module.exports = __webpack_public_path__ + "img/shot_bigtx112102.d23c61ab.png";